<template>
  <router-view/>
</template>

<style lang="scss">
  @import './assets/styles/custom.scss';
  @import '../node_modules/bootstrap/scss/bootstrap.scss';
</style>
